export function getDiscreteBuyInAmounts(buyIn, minBuyIn, maxBuyIn, availableBuyIn) {
    if (availableBuyIn !== undefined && availableBuyIn < minBuyIn) {
        return;
    }
    if (minBuyIn === maxBuyIn) {
        return [buyIn];
    }
    const buyInAmounts = [];
    // add buy-in amounts up to (but not including) the standard buy-in:
    let currBuyIn = minBuyIn;
    while (currBuyIn < buyIn) {
        buyInAmounts.push(currBuyIn);
        currBuyIn += minBuyIn;
    }
    // add buy-in amounts up to (and including) the max buy-in:
    currBuyIn = buyIn;
    while (currBuyIn <= maxBuyIn) {
        buyInAmounts.push(currBuyIn);
        currBuyIn += buyIn;
    }
    if (!buyInAmounts.includes(maxBuyIn)) {
        // if buy-in range is capped, we may not have the max in the list yet
        buyInAmounts.push(maxBuyIn);
    }
    if (availableBuyIn === undefined || availableBuyIn >= maxBuyIn) {
        return buyInAmounts;
    }
    // remove options that the user can't afford, and add the user's bank (available buy-in) as the max buy-in:
    return buyInAmounts.filter((buyInAmount) => buyInAmount < availableBuyIn).concat(availableBuyIn);
}
